<template>
    <div>
        <div class="mb-6 mt-6">
            <button @click="closeEdit()"><p class="fas fa-long-arrow-alt-left text-lg mr-2 text-blue"></p><span class="text-lg text-blue">Back to 'Staff Page'</span></button>
        </div>
        <div v-if="profile.userApproval.status === 0" class="flex justify-center w-full text-red text-xl">
          <i class="fas fa-info-circle mr-2 mt-2 mb-2"></i><span>This Profile is currently being reviewed by our Marketing department. Please await feedback.<br>For any queries, please email <a :href="`mailto:marketing@fineandcountry.com`" class=" hover:underline text-red">marketing@fineandcountry.com</a></span>
        </div>
        <div v-if="profile.userApproval.status === 4" class="flex justify-center w-full text-red text-xl">
          <i class="fas fa-info-circle mr-2"></i><span>Marketing has reviewed and updated some information please check and approve the amends</span>
        </div>
        <div v-if="profile.userApproval.status === 3 && !profile.approved" class="flex justify-center w-full text-red text-xl">
          <i class="fas fa-info-circle mr-2"></i><span>Note: This Profile has not yet been submitted for approval and is currently only a saved draft</span>
        </div>
        <div v-if="profile.userApproval.status === 2" class="flex justify-center w-full text-red text-xl">
          <i class="fas fa-info-circle mr-2"></i><span>Your profile review has been rejected please check the comments and resubmit for approval</span>
        </div>
        <div class="w-full max-w-full overflow-x-auto overflow-y-hidden border-bottom mr-12">
            <div class="flex flex-col items-center sm:flex-row">
                <div class="py-4 pr-10 block uppercase cursor-pointer text-3xl" :class="activeTabUserEdit=='1'?'active':''" @click="activeTabUserEdit = true">
                Account details
                </div>
            </div>
        </div>
        <panel>
            <div>
                <div class="flex flex-wrap -mx-2 text-sm items-stretch border-bottom">
                <!-- LEFT SIDE: Personal Details -->
                <div class="flex-1 w-full lg:w-1/2 px-4">
                    <h1 slot="header" class="w-full text-lg py-4">
                    Personal Details:
                    </h1>
                        <h2 class="text-grey-dark text-sm font-medium leading-normal pb-4 ">
                        These will be your personal details and contact information used for all web and relevant print assets
                        </h2>
                        <personal-details v-model="profile" :errorBag="errorBag" :network="network"></personal-details>
                </div>

                    <!-- RIGHT SIDE: Profile Picture -->
                <profile-image v-model="profile" ></profile-image>
                </div>
                <div class="flex flex-wrap -mx-2 text-xs items-stretch border-bottom">
                    <!-- LEFT SIDE: Admin Access -->
                    <div v-if="profile.type < 8" class="flex-1 w-full lg:w-1/2 px-4">
                        <h1 slot="header" class="w-full text-lg py-4">
                        Admin Access:
                        </h1>
                        <div class=" border-right">
                        <div v-if="profile.type > 3" class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
                            <div class="w-full lg:w-1/2 px-2 mb-4">
                            <label for="name">Administrator Access:</label>
                            <i class="tooltip-container fas fa-info-circle text-blue">
                                    <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                                        <span class="text-black font-sans">This defines the user access level</span>
                                    </div>
                            </i>
                            <select id="type" v-model="profile.type" class="block w-full border hover:border-grey focus:border-grey-dark p-2 mt-2 h-10 text-sm">
                                <option :value="4">Office Admin</option>
                                <option :value="5">Agent</option>
                                <option v-if="profile.type === 8" :value="8">Profile Only</option>

                            </select>
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-2 text-xs border-grey-lighter mb-4">
                            <div class="w-full lg:w-1/1 px-2 mb-4">
                            <div  class="pb-2"><label>Allow access to:</label>
                                <i class="tooltip-container fas fa-info-circle text-blue ml-1">
                                        <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                                            <span class="text-black font-sans">These are the services you have access to directly from the Members Hub</span>
                                        </div>
                                </i>
                            </div>
                            <div v-if="system.external_data.systems_available.includes('referrals')" class="mb-1">
                                <input type="checkbox" class="mr-2" id="referral_system" v-model="profile.referral_system">
                                <label for="referral_system" class="mr-4">Referral System</label>
                            </div>

                            </div>
                        </div>
                        </div>
                    </div>

                        <!-- RIGHT SIDE: Associated Offices -->
                    <div v-if="profile.type !=8" class="w-full lg:w-1/2 px-4 pt-8 pb-4">
                        <div class="pb-2 mr-1"><label>Assigned Offices:</label>
                        <!-- <label class="pb-2 mr-1" v-else >Associated Offices</label> -->
                            <i class="tooltip-container fas fa-info-circle text-blue">
                                <div class="absolute border border-bg-primary p-2 bg-white shadow z-10 rounded text-xs normal-case mt-1 tooltip-msg pointer-events-none">
                                    <span class="text-black font-sans">These are the offices you have been associated with. You can see and update properties and other information from these offices</span>
                                </div>
                            </i>
                        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('assigned_offices')" v-text="errorBag.get('assigned_offices')"></small>
                        <small class="block text-red-dark text-medium mt-2" v-if="errorBag.get('associated_office')" v-text="errorBag.get('associated_office')"></small>
                        </div>
                        <loader v-if="loadingOffices"></loader>
                        <div v-if="!loadingOffices">
                            <div class="flex flex-row flex-wrap" v-if="profile.type > 3">
                                <div class="flex flex-row mb-2 w-1/2" v-for="office in office_list" :key="office.id">
                                    <div class="mr-2" :class="{'opacity-50': (!authUserList.includes(office.id) && (profile_v2.type > 3))} ">
                                        <input type="checkbox" class="mr-2" :value="office.id" :id="office.id" v-bind:checked="profile.assigned_offices.includes(office.id)" :disabled="(!authUserList.includes(office.id) && (profile_v2.type > 3))"  @click="addOffice(office.id)">
                                        <label :for="office.id">{{office.name}} ({{office.town}})</label>
                                    </div>
                                </div>
                            </div>
                            <div class="flex flex-row flex-wrap" v-else>
                              <div>Please use the admin hub to change client admin assigments</div>
                                <!-- <div class="flex flex-row mb-2 w-1/2" v-for="office in associate_office_list"  :key="office.id">
                                    <div :class="{'opacity-50': (!authUserList.includes(office.id) && (profile_v2.type > 3))}">
                                        <input type="checkbox" class="mr-2" :value="office.id" :id="office.id" v-bind:checked="profile.associated_office.includes(office.id)" :disabled="(!authUserList.includes(office.id) && (profile_v2.type > 3))"  @click="addAssociateOffice(office.id)">
                                        <label :for="office.id" class="mr-4 ">{{office.name}}</label>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <social-media v-model="profile"></social-media>
                </div>
            </div>
          <profile-biography v-if="system.external_data.bios === true" v-model="profile"></profile-biography>
        </panel>
        <approval v-model="profile" @submitSave="saveUser(profile)" @approveAmends="approveAmends()" @submitApproval="submitApproval()" @cancelApproval="cancelApproval()" @revertChanges="revertChange()" @open-comment-model="showCommentModal = true"></approval>
        <profile-comment
          v-if="showCommentModal"
          :scrollY="true"
          @dismissed="showCommentModal = false"
          @leave="showCommentModal = false"
          :showCloseBtn="true"
          :user="profile"
        >
        </profile-comment>
      <modal
        v-if="removedAssignedModal"
        :scrollY="false"
        @dismissed="removedAssignedModal = false"
        @leave="removedAssignedModal = false"
        :showCloseBtn="true"
        :modalClass="'bg-white rounded-lg shadow-lg p-6 relative my-6 max-w-lg min-w-1/2'"
      >
      <div class="flex h-full flex-col items-center">
        <div class="p-2 mb-4">
          <p class="text-center text-lg">The user is only assigned to one office removing this will remove the user</p>
        </div>
        <div class="flex items-center">
          <button  @click="removedAssignedModal = false" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Ok
          </button>
        </div>
      </div>
      </modal>
      <modal
        v-if="leaveModal"
        :scrollY="false"
        @dismissed="leaveModal = false"
        @leave="leaveModal = false"
        :showCloseBtn="true"
      >
      <div class="flex h-full flex-col items-center justify-center">
        <div class="p-2 mb-4">
          <p class="text-center">Are you sure you wish to leave before saving your changes?</p>
        </div>
        <div class="flex items-center">
          <button  @click="$emit('close-edit')" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Yes, leave.
          </button>
          <button @click="leaveModal = false" class="bg-white border border-tertiary text-tertiary rounded px-4 py-3 text-sm font-medium align-bottom m-2">
            No, go back.
          </button>
        </div>
      </div>
    </modal>
    </div>
</template>

<script>
import api from '@/http'
import Panel from '../Panel.vue'
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'
import VueAvatar from './VueAvatar.vue'
import ErrorBag from '@/ErrorBag'
import PersonalDetails from './PersonalDetails.vue'
import SocialMedia from './SocialMedia.vue'
import ProfileImage from './ProfileImage.vue'
import Approval from './Approval'
import ProfileBiography from './ProfileBiography.vue'
import ProfileComment from './ProfileComment.vue'
export default {
  components: { Panel, VueAvatar, PersonalDetails, SocialMedia, ProfileImage, Approval, ProfileBiography, ProfileComment },
  name: 'profileAccount',
  props: ['user', 'network'],
  data () {
    return {
      activeTabUserEdit: true,
      office_list: null,
      associate_office_list: null,
      loadingOffices: true,
      fileToBig: false,
      uploadingPhoto: false,
      errorBag: new ErrorBag(),
      authUserList: [],
      userSaving: false,
      showCommentModal: null,
      removedAssignedModal: null,
      profile: this.user,
      initialProfile: null,
      leaveModal: null,
      buttonPress: false
    }
  },
  computed: {
    ...mapState(['selectedOffice', 'system', 'profile_v2'])
  },
  created () {
    this.getOfficeList()
    this.getOfficeListAssociate()
    this.collateAuthUserList()
    this.initialProfile = JSON.parse(JSON.stringify(this.user))
    console.log(this.user)
    // this.profile = this.user
  },
  methods: {
    ...mapActions([
      'displayToastNotification'
    ]),
    closeEdit () {
      if (!this.buttonPress && !_.isEqual(this.initialProfile, JSON.parse(JSON.stringify(this.profile)))) {
        this.leaveModal = true
      } else {
        this.$emit('close-edit')
      }
    },
    prepareToExit (to, from, next) {
      if (!this.buttonPress && !_.isEqual(this.initialProfile, JSON.parse(JSON.stringify(this.profile)))) {
        this.$emit('leaving')
        this.$emit('destination', to)
      } else {
        next()
      }
    },
    addOffice (officeId) {
      // in here you can check what ever condition  before append to array.
      if (this.profile.assigned_offices.length === 1 && this.profile.assigned_offices.includes(officeId)) {
        this.removedAssignedModal = this.profile
      }
      if (this.profile.assigned_offices.includes(officeId)) {
        this.profile.assigned_offices = _.without(this.profile.assigned_offices, officeId)
      } else {
        this.profile.assigned_offices.push(officeId)
      }
    },
    addAssociateOffice (officeId) {
      // in here you can check what ever condition  before append to array.
      if (this.profile.associated_office.includes(officeId)) {
        this.profile.associated_office = _.without(this.profile.associated_office, officeId)
      } else {
        this.profile.associated_office.push(officeId)
      }
    },
    collateAuthUserList () {
      this.profile_v2.offices.forEach(office => {
        this.authUserList.push(office.id)
      })
    },
    async saveUser (val) {
      val['office_id'] = this.selectedOffice.id
      this.errorBag.clear()
      await api.patch('/update-user/' + val.id, val).then(
        response => {
          this.userSaving = false
          this.profile = response.data
          this.initialProfile = JSON.parse(JSON.stringify(this.profile))
          this.displayToastNotification({
            type: 'success',
            icon: 'fa-check',
            title: 'User Updated',
            info: 'Your user has been updated successfully.'
          })
        },
        error => {
          this.errorBag.store(error.response.data)
          this.userSaving = false
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'User',
            info: 'Error saving profile.'
          })
        }
      )
    },
    getOfficeList () {
      var params = {
        office_id: this.selectedOffice.id
      }
      api.get('/user-office-list/' + this.profile.id, { params }).then(response => {
        this.office_list = response.data
        this.loadingOffices = false
      }).catch(({ error }) => {
        if (error.status === 422) {
          this.errorBag.store(error.response.data)
        }
      })
    },
    getOfficeListAssociate () {
      var params = {
        office_id: this.selectedOffice.id
      }
      api.get('/user-office-list-associate/' + this.profile.id, { params }).then(response => {
        this.associate_office_list = response.data
      }).catch(({ response }) => {
        if (response.status === 422) {
        }
      })
    },
    async submitApproval () {
      await this.saveUser(this.profile)
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.post('/submit-approval/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.initialProfile = JSON.parse(JSON.stringify(this.profile))
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Submit approval',
          info: 'Your have successfully submitted for approval.'
        })
      }, error => {
        if (error.response.status === 422) {
          this.errorBag.store(error.response.data)
          this.$emit('savingUser', false)
          this.displayToastNotification({
            type: 'danger',
            icon: 'fa-times-circle',
            title: 'Failed Submission',
            info: 'Error submitting your profile'
          })
        }
      })
    },
    cancelApproval () {
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.post('/cancel-approval/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.initialProfile = JSON.parse(JSON.stringify(this.profile))
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Cancel Approval',
          info: 'Your have successfully cancelled approval process.'
        })
      })
    },
    approveAmends () {
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.post('/approve-amends/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Approved amends',
          info: 'Your have successfully approved'
        })
      })
    },
    revertChange () {
      let params = {
        selectedOffice: this.selectedOffice.id
      }
      api.patch('/revert-user/' + this.profile.id, params).then(response => {
        this.profile = response.data
        this.initialProfile = JSON.parse(JSON.stringify(this.profile))
        this.displayToastNotification({
          type: 'success',
          icon: 'fa-check',
          title: 'Changes reverted',
          info: 'Your changes has reverted'
        })
        this.revertModal = false
      })
    }
  }
}
</script>

<style scoped>

</style>
